<template>
    <div class='root_div'>
        <svg class='svg pc' preserveAspectRatio="none" xmlns:dc="http://purl.org/dc/elements/1.1/" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xl="http://www.w3.org/1999/xlink" viewBox="1380.5 307.5 236.39585 39" width="236.39585" height="39">
          <defs/>
          <g id="版面_____" stroke="none" fill="none" stroke-opacity="1" stroke-dasharray="none" fill-opacity="1">
            <title>主页（手机）</title>
            <g id="版面______图层_2">
              <title>图层 2</title>
              <g id="Graphic_60">
                <path d="M 1416.3094 308 L 1581.0865 308 C 1600.5773 308 1616.3959 316.512 1616.3959 327 C 1616.3959 337.488 1600.5773 346 1581.0865 346 L 1416.3094 346 C 1396.8186 346 1381 337.488 1381 327 C 1381 316.512 1396.8186 308 1416.3094 308 Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
            </g>
          </g>
        </svg>

        
        <el-button class="search_button" @click="dialog_form_confirm_visible=true">
            {{t('__search')}}
            <el-icon class='icon mobile'>
                <Search />
            </el-icon>
            <el-icon class='icon pc'>
                <Search />
            </el-icon>

        </el-button>

        <el-dialog v-model="dialog_form_confirm_visible" :title="t('__title')" :align-center="true" :width="dialog_width">
            <el-form :model="form">
                <el-input v-model="form.name" autocomplete="off" />
            </el-form>
            <template #footer>
              <div class="dialog-footer">
                <el-button @click="dialog_initialisation()">{{t('__serving_robot')}}</el-button>
                <el-button type="primary" @click="dialog_form_confirm_visible = false">{{t('__searching_site')}}</el-button>
              </div>
            </template>
        </el-dialog>

        <el-dialog class='dialog' v-model="dialog_form_visible" :title="t('__title')" :width="dialog_width" :modal="false" :append-to-body="true" modal-penetrable>
            <dialog_scrollbar ref="dialog_scrollbar_ref_pc"/>
            <template #footer>
                <div class='footer'>
                    <el-input class='input' clearable @keyup.enter="send_message()" v-model="input" :placeholder="t('__placeholder')" />
                    <svg class="icon_emoticon" aria-hidden="true" @click="set_emoticon_show()">
                        <use xlink:href="#icon-message_btn_emoticon_select"></use>
                    </svg>
                    <el-button type="primary" round @click="send_message()">{{t('__send')}}</el-button>
                    <Picker v-if="locale=='en' && emoticon_show" :showSkinTones="false" :data="emoji_index" set="apple" :native="true" :perLine="emoji_per_line" :emojiSize="emoji_size" :title="t('__emoticon_title')" @select="show_emoji"/>
                    <Picker v-else-if="emoticon_show"            :showSkinTones="false" :data="emoji_index" set="apple" :native="true" :perLine="emoji_per_line" :emojiSize="emoji_size" :title="t('__emoticon_title')" @select="show_emoji" :i18n="emoji_catogory"/>
                </div>
            </template>
        </el-dialog>

        <Transition name="slide-fade">
            <el-page-header v-if="page_header_visible" class="dialog" :title="t('__go_back')" @back="$emitter.emit('dialog_finish'); page_header_visible=false">
                <template #content>
                    <span> {{t('__title')}} </span>
                </template>
                <div>
                    <dialog_scrollbar ref="dialog_scrollbar_ref_mobile"/>
                    <div class='footer'>
                        <el-input class='input' :size="footer_input_button_size" clearable @keyup.enter="send_message()" v-model="input" :placeholder="t('__placeholder')" />
                        <svg class="icon_emoticon" aria-hidden="true" @click="set_emoticon_show()">
                            <use xlink:href="#icon-message_btn_emoticon_select"></use>
                        </svg>
                        <el-button class="send_button" :size="footer_input_button_size" type="primary" round @click="send_message()">{{t('__send')}}</el-button>
                        <Picker class='emoticon_picker' v-if="locale=='en' && emoticon_show" :showPreview="false" :showSkinTones="false" :data="emoji_index" set="apple" :native="true" :perLine="emoji_per_line" :emojiSize="emoji_size" :title="t('__emoticon_title')" @select="show_emoji"/>
                        <Picker class='emoticon_picker' v-else-if="emoticon_show"            :showPreview="false" :showSkinTones="false" :data="emoji_index" set="apple" :native="true" :perLine="emoji_per_line" :emojiSize="emoji_size" :title="t('__emoticon_title')" @select="show_emoji" :i18n="emoji_catogory"/>
                    </div>
                </div>
    
            </el-page-header>
        </Transition>
    </div>
</template>


<script>
import { ref, reactive, provide } from 'vue'
import { useI18n } from "vue-i18n"
import { useCookies } from "vue3-cookies";
import axios from '../utils/request'
import api from '../api'
import { useWebSocket } from '@vueuse/core'

import { ElButton } from 'element-plus'
import { ElIcon } from 'element-plus'
import { ElInput } from 'element-plus'
import { ElForm } from 'element-plus'
import { ElPageHeader } from 'element-plus'
import { ElDialog } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import { Search } from '@element-plus/icons-vue'
import { ElScrollbar } from 'element-plus'

import dialog_scrollbar from './dialog_scrollbar.vue'
import { mapMutations } from "vuex"


import "emoji-mart-vue-fast/css/emoji-mart.css";
import emoji_catogory_zh_CN from "../assets/emoji_catogory_zh_CN.json"
import emoji_catogory_zh_HK from "../assets/emoji_catogory_zh_HK.json"
import emoji_catogory_zh_TW from "../assets/emoji_catogory_zh_TW.json"
import emoji_data_zh_CN from '../../public/static/emoji_apple_zh_CN.json'
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src"



export default {
    components: {
        ElButton,
        ElIcon,
        Search,
        ElDialog,
        ElForm,
        ElInput,
        ElPageHeader,
        ElScrollbar,
        dialog_scrollbar,
        Picker,
    },

    setup() {

        let form = reactive({
            name: '',
        })
        let dialog_form_confirm_visible = ref(false)
        let dialog_form_visible = ref(false)
        let page_header_visible = ref(false)
        let dialog_width=ref('')
        let window_width=window.screen.width
        let footer_input_button_size=ref('')
        let dialog_scrollbar_ref_mobile=ref()
        let dialog_scrollbar_ref_pc=ref()

        /*
        const dialog_scrollbar_ref = (el) => {
            dialog_scrollbar_ref_array.value[0]=el
        }
        */

        /* footer */
        const input = ref('')
        let emoji_catogory = reactive(emoji_catogory_zh_CN)
        let emoji_index = reactive(new EmojiIndex(emoji_data_zh_CN))
        let emoji_per_line=ref()
        let emoji_size=ref()

        if (window_width >= 1080) {
            dialog_width='5rem'
            emoji_per_line=18
            emoji_size=20
        }
        else if (window_width >= 768) {
            dialog_width='80vw'
            emoji_per_line=16
            emoji_size=34
            footer_input_button_size='large'
        }
        else {
            dialog_width='80vw'
            emoji_per_line=11
            emoji_size=24
            footer_input_button_size='large'
        }

        let emoticon_show=ref(false)


        /*i18n */
        let {t, locale, getLocaleMessage} = useI18n({
                messages: {
                    'en': {
                        '__search': "Search or consult",
                        '__search_canceled': 'Search or consult canceled',
                        '__title': "Search or consult",
                        '__tip': "Please start to consult or input the keyword to search this website",
                        '__serving_robot': "Support Robot",
                        '__searching_site': "Search this site",
                        '__placeholder': "Please input",
                        '__send': "Send",
                        '__emoticon_title': "Emoticon",
                        '__go_back': "Back",
                        '__dialog_initialisation_failed_title': "Failed to initialise the dialog with support robot",
                        '__dialog_robot_greeting': "Hello! This is the support robot Atomic. Nice to provide service to you. Please try to include all necessary information in each speech."
                    },
                    'zh_CN': {
                        "__search": "搜索本站或开始咨询",
                        '__ok': '确定',
                        '__cancel': '取消',
                        '__search_canceled': '搜索或咨询取消',
                        '__title': "搜索本站或开始咨询",
                        '__tip': "请开始咨询或输入关键字进行搜索",
                        '__serving_robot': "客服机器人",
                        '__searching_site': "搜索本站",
                        '__placeholder': "请输入",
                        '__send': "发送",
                        '__emoticon_title': "表情符号",
                        '__go_back': "返回",
                        '__dialog_initialisation_failed_title': "服务机器人初始化失败",
                        '__dialog_robot_greeting': "您好！我是客服机器人Atomic, 很高兴为您服务，请尽量在每次交流当中都包含所有需要的信息。"
                    },
                    'zh_HK': {
                        "__search": "搜索本站或開始咨詢",
                        '__ok': '確認',
                        '__cancel': '取消',
                        '__search_canceled': '搜索取消',
                        '__title': "搜索本站或開始咨詢",
                        '__tip': "請開始咨詢或輸入關鍵字進行搜索",
                        '__serving_robot': "客服機器人",
                        '__searching_site': "搜索本站",
                        '__placeholder': "請輸入",
                        '__send': "發送",
                        '__emoticon_title': "錶情符號",
                        '__go_back': "返迴",
                        '__dialog_initialisation_failed_title': "服務機器人初始化失敗",
                        '__dialog_robot_greeting': "您好！我是客服機器人Atomic, 很高興爲您服務，請盡量在每次交流當中都包含所有需要的信息。"
                    },
                    'zh_TW': {
                        "__search": "搜索本站或開始咨詢",
                        '__ok': '確認',
                        '__cancel': '取消',
                        '__search_canceled': '搜索取消',
                        '__title': "搜索本站或開始咨詢",
                        '__tip': "請開始咨詢或輸入關鍵字進行搜索",
                        '__serving_robot': "客服機器人",
                        '__searching_site': "搜索本站",
                        '__placeholder': "請輸入",
                        '__send': "發送",
                        '__emoticon_title': "錶情符號",
                        '__go_back': "返迴",
                        '__dialog_initialisation_failed_title': "服務機器人初始化失敗",
                        '__dialog_robot_greeting': "您好！我是客服機器人Atomic, 很高興爲您服務，請盡量在每次交流當中都包含所有需要的信息。"
                    }
                }
            });

        let sentences=reactive([])

        provide('sentences', sentences);

        let websocket=null
        let websocket_url=ref('')

        return {
            t
            ,locale
            ,getLocaleMessage
            ,sentences
            ,dialog_form_confirm_visible
            ,dialog_form_visible
            ,page_header_visible
            ,dialog_width
            ,dialog_scrollbar_ref_pc
            ,dialog_scrollbar_ref_mobile
            ,window_width
            ,emoji_per_line
            ,emoji_size
            ,form
            ,input
            ,emoji_data_zh_CN
            ,emoji_catogory
            ,emoji_index
            ,emoticon_show
            ,footer_input_button_size
            ,websocket
            ,websocket_url
        }
    },


    methods: {

        ...mapMutations(["set_set_emoticon_flag"]),
        ...mapMutations(["set_dialoge_initialisation"]),

        show_emoji(emoji) {
            this.input = this.input + emoji.native;
        },

        set_emoticon_show() {
            //console.log("set_emoticon_show")
            this.emoticon_show=(!this.emoticon_show)
            if (this.window_width >= 1080) {
                this.dialog_scrollbar_ref_pc.set_dialog_scrollbar_max_height(this.emoticon_show)
            }
            else {
                this.dialog_scrollbar_ref_mobile.set_dialog_scrollbar_max_height(this.emoticon_show)
            }
            /*
            console.log("this.sentences_ref.clientHeight=", JSON.stringify(this.sentences_ref.clientHeight))
            console.log("this.dialog_scrollbar_max_height=", JSON.stringify(this.dialog_scrollbar_max_height))
            let scroll_top = null
            if (this.window_width >= 1080) {
                140px=1rem
                scroll_top = Math.max(this.sentences_ref.clientHeight - new Number(this.dialog_scrollbar_max_height.replace('rem','')) * 140, 0)
            }
            else {
                scroll_top = Math.max(this.sentences_ref.clientHeight - new Number(this.dialog_scrollbar_max_height.replace('vw','')) * this.window_width/100, 0)
            }
            console.log("scroll_top=", JSON.stringify(scroll_top))
            this.dialog_scrollbar_ref.scrollTo({ top: this.dialog_scrollbar_ref.wrapRef.scrollHeight, left: 0, smooth: false })
            */
            this.set_set_emoticon_flag(true)
        },

        update_cookie_expire_date() {
            let { cookies } = useCookies()
            let token = cookies.get('token')
            cookies.set("token", token, -1)
            //console.log("token=",token)
            return token
        },

        send_initial() {
            let token = this.update_cookie_expire_date()
            this.websocket.send(JSON.stringify({"token": token}))
            let temp_input = this.form.name.trim()
            //console.log("temp_input=",temp_input)
            if (temp_input != '') {
                    this.websocket.send(this.add_sentence(temp_input))
            }
            this.$emitter.emit('add_to_history');
            //console.log("this.sentences4=", JSON.stringify(this.sentences))
        },

        add_sentence (sentence) {//服务器不保存第0条，不发送role，
            //console.log("add_sentence")
            //console.log("this.sentences3=", JSON.stringify(this.sentences))
            let last_id = this.sentences.at(-1).id
            //console.log("last_id=", last_id)
            let message_object = {  id: last_id+1,
                                    content: sentence,
                                    role: "user" }
            this.sentences.push(message_object)
            this.$emitter.emit('add_to_history');
            let clone_message_object = Object.assign({}, message_object);
            delete clone_message_object.role
            let message = JSON.stringify(clone_message_object)
            //console.log("message=",clone_message_object)
            return message
        },

        send_message() {
            if (this.input.trim()=='') {
                return
            }
            this.update_cookie_expire_date()
            this.websocket.send(this.add_sentence(this.input)); 
            this.input=''
        },

        dialog_pre_initialisation(){
            let local_message = this.getLocaleMessage(this.locale)
            this.dialog_form_confirm_visible = false; 
            this.dialog_form_visible = (this.window_width >= 1080);
            this.page_header_visible = (this.window_width < 1080);
            let { cookies } = useCookies()
            const self = this; // 保存Vue组件的this

            if (cookies.isKey('token')) {
                api.get_history()
                .then((res)=>{
                    let history=res.data["history"]
                    //console.log("history=", history)
                    while (this.sentences.length !=0) {
                        this.sentences.pop()
                    }
                    this.sentences.push({id: 0,
                                        content: local_message["__dialog_robot_greeting"],
                                        role: "system"})
                    for (let sentence of history) {
                        this.sentences.push(sentence)
                    }
                    this.send_initial()
                    //console.log("sentences=", this.sentences)
                    //start_websocket_and_send_input
                    //console.log("dialog_form_visible=", this.dialog_form_visible)
                    //console.log("this.websocket=", this.websocket)
                    /*
                    this.websocket =  useWebSocket(process.env.VUE_APP_API_WEBSOCKET_URL+ "/chat_socket/" + token + uuid4(), {
                            onConnected: (ws)=>{
                                console.log("this.websocket=", this.websocket)
                                console.log("ws=", ws)
                                let temp_input = this.form.name.trim()
                                console.log("temp_input=",temp_input)
                                if (temp_input != '') {
                                    ws.send(this.add_sentence(temp_input))
                                }
                                console.log("dialog_form_visible=", this.dialog_form_visible)
                                console.log("this.sentences4=", JSON.stringify(this.sentences))
                            },
                            onMessage: (ws, event)=>{
                                console.log("event.data=", event.data)
                                let reader = new FileReader()
                                reader.readAsText(event.data, 'utf-8')
                                reader.onload = e => {
                                    let message_object = JSON.parse(reader.result)
                                    console.log("message_object=", message_object)
                                    message_object.role = "system"
                                    this.sentences.push(message_object)
                                    event.preventDefault()
                                }
                            },
                            onDisconnected(ws, event) {
                                console.log('Disconnected!', event.code)
                            },
                            onError(ws, event) {
                                console.error('Error:', event)
                            },
                    })
                    */
                })
                .catch(()=>{
                    ElMessageBox.prompt(
                    local_message['__dialog_initialisation_failed_title'],
                    local_message['__dialog_initialisation_failed_title'],
                    {
                        confirmButtonText: local_message['__ok'],
                        // cancelButtonText: local_message['__cancel'],
                        showCancelButton: false,
                        showInput: false,
                        type: 'primary',
                        closeOnClickModal: false,
                    })
                    .catch(()=>{})
                    return
                }) 
            }
            else {
                api.get_token()
                .then((res)=>{
                    let token = res.data['token']
                    cookies.set("token", token, -1)
                    //console.log("this.sentences1=", JSON.stringify(this.sentences))

                    while (this.sentences.length !=0) {
                        this.sentences.pop()
                    }
                    this.sentences.push({id: 0,
                                        content: local_message["__dialog_robot_greeting"],
                                        role: "system"})
                    //console.log("this.sentences2=", JSON.stringify(this.sentences))
                    this.send_initial()
                    //start_websocket_and_send_input
                    /*
                    this.websocket =  useWebSocket(process.env.VUE_APP_API_WEBSOCKET_URL+ "/chat_socket/" + token + uuid4(), {
                            onConnected: (ws)=>{
                                let temp_input = this.form.name.trim()
                                console.log("temp_input=",temp_input)
                                if (temp_input != '') {
                                    ws.send(this.add_sentence(temp_input))
                                }
                                console.log("this.sentences4=", JSON.stringify(this.sentences))
                            },
                            onMessage: (ws, event)=>{
                                console.log("event.data=", event.data)
                                let reader = new FileReader()
                                reader.readAsText(event.data, 'utf-8')
                                reader.onload = e => {
                                    let message_object = JSON.parse(reader.result)
                                    console.log("message_object=", message_object)
                                    message_object.role = "system"
                                    this.sentences.push(message_object)
                                    event.preventDefault()
                                }
                            },
                            onDisconnected(ws, event) {
                                console.log('Disconnected!', event.code)
                            },
                            onError(ws, event) {
                                console.error('Error:', event)
                            },
                    })
                    */
                })
                .catch(()=>{
                    ElMessageBox.prompt(
                    local_message['__dialog_initialisation_failed_title'],
                    local_message['__dialog_initialisation_failed_title'],
                    {
                        confirmButtonText: local_message['__ok'],
                        // cancelButtonText: local_message['__cancel'],
                        showCancelButton: false,
                        showInput: false,
                        type: 'primary',
                        closeOnClickModal: false,
                    }
                    ).catch(()=>{})
                    return
                })
            }
        },

        dialog_initialisation() {
            this.dialog_pre_initialisation()
            //console.log("this.dialog_scrollbar_ref=", this.dialog_scrollbar_ref)
            //console.log("dialog_pre_initialisation")
            this.$emitter.emit('dialog');
            //console.log('emitter');
        }
    },

    mounted() {
        if (this.locale != 'zh_CN') {
            axios.get('/static/emoji_apple_'+ this.locale + '.json').then(
                (res)=>{
                   this.emoji_index=new EmojiIndex(res.data);
                }
            )
        }
        if (this.locale == 'zh_CN') {
            this.emoji_catogory=emoji_catogory_zh_CN
            this.emoji_index=new EmojiIndex(this.emoji_data_zh_CN)
        }
        else if (this.locale == 'zh_HK') {
            this.emoji_catogory=emoji_catogory_zh_HK
        }
        else if (this.locale == 'zh_TW') {
            this.emoji_catogory=emoji_catogory_zh_TW
        }

        this.websocket=useWebSocket(process.env.VUE_APP_API_WEBSOCKET_URL, {
            onConnected: (ws)=>{
            },
            onMessage: (ws, event)=>{
                //console.log("event.data=", event.data)
                let reader = new FileReader()
                reader.readAsText(event.data, 'utf-8')
                reader.onload = e => {
                    let message_object = JSON.parse(reader.result)
                    //console.log("message_object=", message_object)
                    message_object.role = "system"
                    this.sentences.push(message_object)
                    this.$emitter.emit('add_to_history');
                    event.preventDefault()
                }
            },
            onDisconnected(ws, event) {
                console.log('Disconnected!', event.code)
            },
            onError(ws, event) {
                console.error('Error:', event)
            }
        })
    }
}

</script>

<style scoped>

    .icon {
        display: block;
        color: var(--el-color-primary);
    }

    .search_button {
        border-radius: 0;
        border: 1px solid rgb(197, 197, 197);
    }

    .search_button>:deep(span) {
        justify-content: space-between;
        width: 100%;
        border: 0;
    }

    .root_div {
        position: relative;
    }

    .dialog {
        position: relative;
    }

    .footer {
        position: absolute;
        bottom: 0;
    }

    .icon_emoticon {
        fill: currentColor;
        overflow: hidden;
        position: relative;
    }

    .input {
        position: relative;
    }

    .slide-fade-enter-active {
      transition: all 0.8s ease-out;
    }

    .slide-fade-leave-active {
      transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,.slide-fade-leave-to {
      transform: translateX(-20px);
      opacity: 0;
    }

    @media screen and (max-width: 768px){

        .pc {
            display: none
        }

        .search_button {
            size: default;
            width: 34.5vw;
            height: 6.2vw;
            padding: 0 1vw;
            height: 6.5vw;;
        }

        .search_button>:deep(span) {
            font-size: 3vw;
        }

        .footer {
            --el-font-size-base: 2vw;
            right: 0.5vw;
            font-size: 5vw;
        }

        .dialog {
            position: absolute;
            width: 100vw;
            height: 100vh;
            left: -39vw;
            top: -1.5vw;
            background-color: white;
            z-index: 20;
        }

        .icon_emoticon {
            width: 8.5vw;
            height: 8.5vw;
            bottom: -2.4vw;
            margin: 0 0.5vw;
        }

        .input {
            width: 72vw;
            left: 0;
            font-size: 3vw;
        }

        .send_button {
            --el-font-size-base: 4vw
        }

    }

    @media screen and (max-width: 1080px) and (min-width: 768px){

        .pc {
            display: none
        }

        .root_div {
            height: 5.75vw;
            width: 37vw;
        }

        .search_button {
            position: absolute;
            size: default;
            width: 36vw;
            padding: 0 0.6vw;
            height: 5.75vw;
            left: 0;
            top: 0.15vw;
        }

        .search_button>:deep(span) {
            font-size: 3vw;
        }

        .footer {
            --el-font-size-base: 2vw;
            right: 0.5vw;
            font-size: 5vw;
        }

        .dialog {
            position: absolute;
            width: 100vw;
            height: 100vh;
            left: -38.5vw;
            top: -1.5vw;
            background-color: white;
            z-index: 20;
        }

        .icon_emoticon {
            width: 4.5vw;
            height: 4.5vw;
            bottom: -0.95vw;
            margin: 0 0.5vw;
        }

        .input {
            width: 83vw;
            left: -0.018rem;
            font-size: 2.5vw;
        }

        .emoticon_picker {
            position: relative;
            left: 0vw;
        }

        .send_button {
            --el-font-size-base: 2vw
        }

    }

    @media screen and (min-width: 1080px){
        .mobile {
            display: none
        }

        .search_button {
            line-height: 0.386rem;
            width: 1.52rem;
            height: 0.386rem;
            padding: 0 0;
            position: relative;
            border: 0;
            background-color: rgba(255, 255, 255, 0);
        }

        .search_button>:deep(span) {
            padding:0 0.15rem;
            position: absolute;
            top: 0.02rem;
            left: 0;
            font-size:0.11rem;
        }

        .icon {
            top: 0.01rem;
            right: 0.3rem;
            font-size: 0.15rem;
        }

        .svg {
            position: absolute;
            width: 100%;
            height: 65%;
            top: 0.09rem;
            left: 0rem;
        }

        .icon_emoticon {
            width: 0.2rem;
            height: 0.2rem;
            bottom: -0.06rem;
            margin: 0 0.02rem;
        }

        .input {
            width: 4.15rem;
            left: -0.018rem;
        }

        .dialog {
            position: absolute;
            top: 0;
            right: 0;
            height: 5rem;
        }

        .send_button {
            --el-font-size-base: 0.5rem;
        }

    }


</style>
<style>
    @media screen and (max-width: 768px){
        .el-page-header__title {
            font-size: 4vw;
            font-weight: 400
        }
    }
    @media screen and (max-width: 1080px) and (min-width: 768px){
        .el-page-header__title {
            font-size: 2.25vw;
            font-weight: 400
        }
    }
</style>